import { createTheme } from '@mui/material/styles';
import { mvkgTokens, shellTokens } from './mvkgTokens';

export function createMvkgTheme() {
  return createTheme({
    palette: {
      mode: 'light',
      primary: {
        main: mvkgTokens.brand.main,
        light: mvkgTokens.brand.light,
        dark: mvkgTokens.brand.dark,
        contrastText: mvkgTokens.brand.contrastText,
      },
      secondary: {
        main: '#10b981',
        light: '#34d399',
        dark: '#059669',
      },
      background: {
        default: mvkgTokens.surface.default,
        paper: mvkgTokens.surface.paper,
      },
      success: { main: '#22c55e' },
      warning: { main: '#f59e0b' },
      error: { main: '#ef4444' },
      info: { main: '#3b82f6' },
      text: {
        primary: '#0f172a',
        secondary: '#64748b',
      },
    },
    shape: { borderRadius: mvkgTokens.radius.md },
    typography: {
      fontFamily: mvkgTokens.font.body,
      // Prototype intentionally uses Inter @ 700 (not font-black) with tight tracking.
      h3: { fontWeight: 700, fontFamily: mvkgTokens.font.display, letterSpacing: '-0.02em', lineHeight: 1.1 },
      h4: { fontWeight: 700, fontFamily: mvkgTokens.font.display, letterSpacing: '-0.01em', lineHeight: 1.15 },
      h5: { fontWeight: 700, fontFamily: mvkgTokens.font.display, letterSpacing: '-0.01em' },
      h6: { fontWeight: 700, fontFamily: mvkgTokens.font.display, letterSpacing: '-0.01em' },
      subtitle1: { fontWeight: 600 },
      subtitle2: { fontWeight: 600 },
      button: { fontWeight: 700 },
    },
    components: {
      MuiCssBaseline: {
        styleOverrides: {
          body: {
            backgroundColor: mvkgTokens.surface.default,
            backgroundImage: mvkgTokens.gradient.page,
            backgroundAttachment: 'fixed',
            fontFamily: mvkgTokens.font.body,
          },
        },
      },
      MuiButton: {
        defaultProps: { disableElevation: true },
        styleOverrides: {
          root: {
            borderRadius: mvkgTokens.radius.md,
            textTransform: 'none',
            fontWeight: 700,
          },
        },
      },
      MuiCard: {
        styleOverrides: {
          root: {
            borderRadius: mvkgTokens.radius.xl,
            boxShadow: mvkgTokens.shadow.card,
          },
        },
      },
      MuiPaper: {
        styleOverrides: {
          root: { borderRadius: mvkgTokens.radius.md },
        },
      },
      MuiChip: {
        styleOverrides: {
          root: { fontWeight: 600 },
        },
      },
      // Dialogs, menus and popovers take the reader card radius (12). The
      // theme's 16px unit made `borderRadius: 3/4` in a dialog's sx 48-64px
      // pills; local overrides now use shellTokens.dialogRadius too.
      MuiDialog: {
        styleOverrides: {
          paper: { borderRadius: shellTokens.dialogRadius },
        },
      },
      MuiPopover: {
        styleOverrides: {
          paper: { borderRadius: shellTokens.dialogRadius },
        },
      },
    },
  });
}
